import { createSelector } from '@reduxjs/toolkit';
import { SettingKey, Setting } from '../../models/setting.model';
import { ContentModel } from '../../models/content.model';
import { merge } from 'lodash';
import defaultContent from 'utils/data';

const selectSettingsState = (state: any) => state.setting;

export const selectSettingsSelector = createSelector(
  [selectSettingsState],
  (setting) => setting.settings.filter((setting: Setting) => setting.setting_key !== SettingKey.PAGE_CONTENT) || []
);

export const selectSettingLoading = createSelector(
  [selectSettingsState],
  (setting) => setting.loading
);

export const selectCurrentSetting = createSelector(
  [selectSettingsState],
  (setting) => setting.currentSetting
);

export const selectSettingsByCategory = (category: string) => createSelector(
  [selectSettingsSelector],
  (settings) => settings.filter((setting: Setting) => setting.category === category)
);

export const selectPageContent = createSelector(
  [selectSettingsState],
  (setting) => ({
    pageContent: merge({}, defaultContent, setting.settings?.find((setting: Setting) => setting.setting_key === SettingKey.PAGE_CONTENT)?.setting_value as unknown as ContentModel || {}),
    loading: setting.loading
  })
);

export const selectMaintenanceMode = createSelector(
  [selectSettingsState],
  (setting) => setting.settings?.find((setting: Setting) => setting.setting_key === SettingKey.MAINTENANCE_MODE)?.setting_value as boolean || false
);